<template>
  <div class="container-chart">
    <div class="flex-top-box">
      <div class="title-box">{{ $t('chartView.profitStatistics') }}</div>
    </div>
    <div class="chart-body">
      <div class="chartFinal" :class="{orange : orange}">{{ total_profits }} {{ $t('chartView.currency') }}</div>
      <Chart
        type="line"
        :data="chartData"
        :options="chartOptions"
        class="chartMain"
      />
    </div>
  </div>
</template>

<script setup>
// imports
import { ref, onMounted , defineProps } from "vue";
import Chart from "primevue/chart";

//props
const props = defineProps(["total_profits" , "orange"]);
// reactive state
const chartData = ref();
const chartOptions = ref();

// i18n
import { useI18n } from "vue-i18n";
const { t } = useI18n();

// lifecycle hooks
onMounted(() => {
  chartData.value = setChartData();
  chartOptions.value = setChartOptions();
  console.log(props);
});

const setChartData = () => {
  //   const documentStyle = getComputedStyle(document.documentElement);

  return {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ],
    datasets: [
      {
        label: t('chartView.profits'),
        data: [60, 65, 55, 60, 54, 52, 55, 58, 44, 45, 60, 62],
        fill: true,
        borderColor: "#29235c",
        tension: 0.5,
        // background: "red",
        pointRadius: 0
      },
    ],
  };
};
const setChartOptions = () => {
  return {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      legend: {
        display: false,
        labels: {
          color: "#fff",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6d6969",
        },
        grid: {
          display: false,
          color: "#fff",
        },
      },
      y: {
        display: false,
        ticks: {
          color: "#fff",
        },
        grid: {
          color: "#fff",
        },
      },
    },
  };
};
</script>
